export default defineNuxtRouteMiddleware(async (to, from) => {
  if (to.query.linkId && to.query.sourceId && to.query.tenantId) {
    const trackdeskQuery = {
      link_id: to.query.linkId,
      tenant_id: to.query.tenantId,
      source_id: to.query.sourceId,
    };
    useCookie("trackdesk").value = JSON.stringify(trackdeskQuery);
  }
});
